export default __webpack_public_path__ + "static/media/right-chevron-ICN.243f2c75.svg";